import { render } from "./EditMobileNumber.vue?vue&type=template&id=0c4ce947"
import script from "./EditMobileNumber.vue?vue&type=script&lang=js"
export * from "./EditMobileNumber.vue?vue&type=script&lang=js"

import "./EditMobileNumber.vue?vue&type=style&index=0&id=0c4ce947&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__